import React from 'react'
import { chain, omit } from 'lodash'
import PropTypes from "prop-types"

import Button from '../../components/Button.jsx'
import { randstr } from '../../../lib/Tools'

import Dish from './Dish'
import Categories from './CartaCategories'
import emptyDish from './emptyDish'

import "./Carta.less"

const Carta = ({ carta, onChange }) => (    
  <React.Fragment>
    <Categories
      categories={carta.categories || {}}
      onChange={categories => onChange({ categories })}
    />
      
    <div style={{ marginTop: 10 }}>
      {
        chain(carta.dishes)
          .values()
          .sortBy(dish => (
            dish.category && carta.categories[dish.category] 
              ? carta.categories[dish.category].order 
              : -1
          ))
          .value()
          .map(dish => (
            <Dish 
              key={dish.id}
              dish={dish} 
              categories={carta.categories}
              onChange={change => {                    
                onChange({ dishes: { ...carta.dishes, [dish.id]: { ...carta.dishes[dish.id], ...change } } })
              }}
              onRemove={() => onChange({ dishes: omit(carta.dishes, dish.id) })}
            />
          ))
      }
      <Button 
        glyph={'plus'}
        onClick={() => {
          const id = randstr(12)
          onChange({ dishes: { ...carta.dishes, [id]: { ...emptyDish, id } } })
        }}
      >
          Añadir plato
      </Button> 
    </div>
  </React.Fragment>
)

Carta.propTypes = {
  onChange: PropTypes.func.isRequired,
  carta: PropTypes.object.isRequired,
}

export default Carta
